import React from "react";
import PropTypes from "prop-types";
import className from "./style.module.scss";
import { ColorCheckBox } from "./ColorCheckBox";

export function ColorBoxGroup(props) {
  const renderCheckbox = (checkbox, key) => (
    <ColorCheckBox key={key} {...checkbox} onChange={props.onChange} />
  );

  return (
    <div className={`${className.boxGroup} ${props.className}`}>
      {props.checkboxes.map(renderCheckbox)}
    </div>
  );
}

ColorBoxGroup.propTypes = {
  /**
   * className to set on Component;
   */
  className: PropTypes.string,
  /**
   * List of checkboxes to display
   */
  checkboxes: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * name prop to set on radio-button
       */
      name: PropTypes.string,
      /**
       * Value prop to set on radio button
       */
      value: PropTypes.string,
      /**
       * Boolean to set if radio is checked
       */
      checked: PropTypes.bool,
      /**
       * label for the option
       */
      label: PropTypes.string,
      /**
       * style object to set on checkbox
       */
      style: PropTypes.object,
      /**
       * Bolean to set if option is disabled
       */
      disabled: PropTypes.bool,
    })
  ),
  /**
   * Function involked when radio checked
   */
  onChange: PropTypes.func,
};

ColorBoxGroup.defaultProps = {};
